import React from "react";

export default class BottomNavigation extends React.Component {
  constructor(props) {
    super(props);

    this.defaultStyle = {
      minHeight: "56px",
      height: "56px"
    };
  }

  render() {
    const children = React.Children.map(this.props.children, (child, index) =>
      React.cloneElement(child, {
        onClick: () => this.props.onChange(index)
      })
    );

    return (
      <div
        style={this.defaultStyle}
        className="w-full flex items-center justify-around text-grey-darker border-t-1 border-grey-light shadow-md"
      >
        {children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/BottomNavigation/BottomNavigation.js